<template>
  <div class="publicMain">
    <el-row class="leftClass">
      <el-col :span="6">
        <label style="width: 100px;"
          >{{ $t("yhgl.NameOrNumber") }}：</label
        >
        <el-input
          v-model="queryForm.yhbh"
          clearable
          size="small"
          style="width: 60%;" :placeholder="$t('yhgl.qsrxmhzh')"
        ></el-input>
      </el-col>
    </el-row>
    <el-row class="rightClass">
      <el-col :span="12" style="text-align: left;">
        <el-button size="small" type="primary" @click="openDialog('add')">{{
          $t("common.addedBtn")
        }}</el-button>
      </el-col>
      <el-col :span="12">
        <el-button size="small" type="primary" @click="searchUser('query')">{{
          $t("yhgl.queryBtn")
        }}</el-button>
        <el-button size="small" @click="resetSearch('reset')">{{
          $t("yhgl.resetBtn")
        }}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
        :data="tableData"
        border
        style="width: 100%; font-size: 12px;"
        :header-cell-style="$store.state.headerCellStyle"
        :cell-style="$store.state.cellStyle"
      >
        <el-table-column
          prop="rn"
          :label="$t('yhgl.tableSortNum')"
          width="80px"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="yhmc"
          :label="$t('yhgl.queryFormName')"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="zjh"
          :label="$t('yhgl.tableColCard')"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="yhbh"
          :label="$t('yhgl.queryFormLoginName')"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="email"
          :label="$t('yhgl.tableColEmail')"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="tel"
          :label="$t('yhgl.tableColTel')"
          header-align="center"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="jsname"
          :label="$t('yhgl.tableColRole')"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          :label="$t('yhgl.operation')"
          header-align="center"
          width="100px"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="openDialog('edit', scope.row)">{{
              $t("yhgl.editBtn")
            }}</el-button>
            <el-button
              type="text"
              :disabled="scope.row.yhbh == $store.state.userInfo.yhbh"
              @click="openDialog('del', scope.row)"
              >{{ $t("yhgl.deleteBtn") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <!-- 分页组件 -->
      <Pagination
        :currentPage="currentPage"
        :total="total"
        :limit="limit"
        :small="true"
        :pageSizes="$store.state.pageSizes"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-row>
    <!-- 用户信息模态框 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      @close="handleClose"
    >
      <label slot="title">
        <i :class="dialogTitleIcon" style="font-size: 16px; font-weight: bold;">
          <span style="margin-right: 5px;">
            {{ this.dialogTitle }}
          </span>
        </i>
      </label>
      <el-card style="padding: 0 20% 0 20%">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          :validate-on-rule-change="false"
          size="small"
        >
          <el-form-item
            :label="$t('yhgl.queryFormName')"
            prop="yhmc"
            class="formClass"
          >
            <el-input
              v-model="ruleForm.yhmc"
              maxlength="10"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('yhgl.queryFormLoginName')" prop="yhbh">
            <el-input
              :disabled="disabledFlg"
              v-model="ruleForm.yhbh"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('yhgl.tableColCard')" prop="zjh">
            <el-input v-model="ruleForm.zjh"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('yhgl.formPwd')"
            prop="yhmm"
            v-show="showFlg"
          >
            <el-input v-model="ruleForm.yhmm" show-password></el-input>
          </el-form-item>
          <el-form-item :label="$t('yhgl.tableColEmail')" prop="email">
            <el-input v-model="ruleForm.email"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yhgl.tableColTel')" prop="tel">
            <el-input v-model="ruleForm.tel"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yhgl.tableColRole')" prop="jsids">
            <el-select
              v-model="ruleForm.jsids" multiple collapse-tags
              :placeholder="$t('yhgl.ruleSelectMsg') + $t('yhgl.tableColRole')">
              <el-option
                v-for="item in optionsRole"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">{{
          $t("yhgl.cancelBtn")
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          @click="submitForm('ruleForm')"
          >{{ $t("yhgl.saveBtn") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "yhgl",
  computed: {
    rules() {
      // 模态框数据校验规则
      return {
        yhmc: [
          {
            required: true,
            message:
              this.$t("yhgl.ruleBlurMsg") + this.$t("yhgl.queryFormName"),
            trigger: "blur",
          },
        ],
        yhbh: [
          {
            required: true,
            message:
              this.$t("yhgl.ruleBlurMsg") + this.$t("yhgl.queryFormLoginName"),
            trigger: "blur",
          },
        ],
        zjh: [{ required: true, validator: this.$comUtils.validateIdCard, trigger: "blur" }],
        yhmm: [
          { required: true, validator: this.validatePassWord, trigger: "blur" },
        ],
        email: [{ required: true, validator: this.$comUtils.validateEmail, trigger: "blur" }],
        tel: [{ required: true, validator: this.$comUtils.validateMobilePhone, trigger: "blur" }],
        jsids: [
          {
            required: true,
            message:
              this.$t("yhgl.ruleSelectMsg") + this.$t("yhgl.tableColRole"),
            trigger: "change",
          },
        ],
      };
    },
    tabHeight() {
      return this.screenHeight - 385;
    },
  },
  data() {
    return {
      queryForm: {
        yhmc: "",
        yhbh: "",
      },
      tableData: [],
      dialogFormVisible: false,
      dialogTitle: "", // 模态框标题
      dialogTitleIcon: "", // 模态框标题图标
      ruleForm: {
        pwdcheck: "",
        yhmc: "",
        yhbh: "",
        zjh: "",
        yhmm: "",
        email: "",
        tel: "",
        jsids: [],
      },
      currentPage: 1, // 页码
      limit: this.$store.state.dataDisplayNum, // 分页显示条数
      total: 0, // 列表数据量
      pageSizes: this.$store.state.pageSizes, // 分页显示可选择条数
      tabLoading: true, // 表格请求数据loading层
      disabledFlg: false, // 输入框是否可编辑
      showFlg: false, // 元素是否显示
      optionsRole: [], // 用户角色
      saveFlg: "", // 保存操作区分
      optionsUserState: [], // 用户状态
      tmpPwd: "",
      screenHeight: "0",
    };
  },
  methods: {
    validatePassWord(rule, value, callback) {
      if (this.ruleForm.pwdcheck == '1'){
        callback();
      }else {
        if (value == "") {
          callback(new Error("密码不能为空"));
        } else if (value.length < 6 || value.length > 20) {
          callback(new Error("密码长度最小6位、最大20位"));
        } else {
          callback();
        }
      }
    },
    /** 查询用户 */
    searchUser(typeFlg) {
      let _this = this;
      _this.tableData = [];
      if (typeFlg == "reset" || typeFlg == "del" || typeFlg == "query") {
        _this.queryForm.currentPage = 1;
        _this.queryForm.limit = _this.$store.state.dataDisplayNum;
        _this.currentPage = 1;
      } else {
        _this.queryForm.currentPage = _this.currentPage;
        _this.queryForm.limit = _this.limit;
      }
      _this.tabLoading = true; // 关闭请求时的loading层
      _this.$ajax
        .post("/api/searchUser", _this.queryForm)
        .then((res) => {

          _this.tabLoading = false; // 关闭请求时的loading层
          if (res.data.code == "200") {

            if (res.data.data.length > 0) {
              _this.total = res.data.data[0].tableCount;
            } else {
              _this.total = 0;
            }
            _this.tableData = res.data.data;
          }
        })
        .catch((error) => {
          _this.tabLoading = false; // 关闭请求时的loading层
        });
    },
    handleClose(done) {
      this.$refs["ruleForm"].resetFields();
    },
    /** 打开模态框 */
    openDialog(flg, row) {
      if (flg == "add") {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = this.$t("yhgl.addDiaTitle");
          this.dialogTitleIcon = "el-icon-document-add";
          this.disabledFlg = false;
          this.showFlg = true;
        });
      } else if (flg == "edit") {
        this.dialogFormVisible = true;
        this.$nextTick(() => {
          this.dialogTitle = this.$t("yhgl.editDiaTitle");
          this.dialogTitleIcon = "el-icon-edit-outline";
          this.ruleForm.yhmc = row.yhmc;
          this.ruleForm.yhbh = row.yhbh;
          this.ruleForm.pwdcheck = '1';
          this.ruleForm.zjh = row.zjh;
          this.ruleForm.email = row.email;
          this.ruleForm.tel = row.tel;
          if (this.$comUtils.isEmpty(row.jsid)) {
            this.ruleForm.jsids = [];
          } else {
              var jsidlist = row.jsid.split(",");
              var str = [];
              /*str = "[\"";*/
              for (let j = 0; j < jsidlist.length; j++) {
                str.push(jsidlist[j])   ;
              }
            this.ruleForm.jsids = str;
          }
          this.disabledFlg = true;
          this.showFlg = false;
        });
      } else if (flg == "del") {
        this.delUser(row.yhbh);
      }
      this.saveFlg = flg;
    },
    /** 保存模态框数据 */
    submitForm(formName) {
      console.log(formName);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.saveFlg === "add") {
            this.addUser();
          } else if (this.saveFlg === "edit") {
            this.editUser();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /** 添加用户 */
    addUser() {
      let _this = this;
      _this.$ajax
        .post("/api/addUser", _this.ruleForm)
        .then((res) => {
          _this.dialogFormVisible = false;
          if (res.data.code == "200") {
            _this.searchUser();
            _this.$message.success(_this.$t("yhgl.addSuccess"));
          }
        })
        .catch((error) => {
          _this.dialogFormVisible = false;
       });
    },
    /** 编辑用户 */
    editUser() {
      let _this = this;
      _this.$ajax
        .post("/api/updateUser", _this.ruleForm)
        .then((res) => {
          _this.dialogFormVisible = false;
          if (res.data.code == "200") {
            _this.searchUser();
            _this.$message.success(_this.$t("yhgl.editSuccess"));
          }
        })
        .catch((error) => {
          _this.dialogFormVisible = false;
        });
    },
    /** 删除用户 */
    delUser(suid) {
      let _this = this;
      _this
        .$confirm(
          _this.$t("yhgl.deleteContent"),
          _this.$t("yhgl.deleteTitle"),
          {
            distinguishCancelAndClose: true,
            confirmButtonText: _this.$t("yhgl.confirmBtn"),
            cancelButtonText: _this.$t("yhgl.cancelBtn"),
          }
        )
        .then((res1) => {
          _this.$ajax
            .post("/api/delUser", _this.$qs.stringify({ suid: suid }))
            .then((res) => {
              if (res.data.code == "200") {
                _this.searchUser("del");
                _this.$message.success(_this.$t("yhgl.delSuccess"));
              }
            });
        })
        .catch((action) => {
          // this.$message.info({
          //   message: action === 'cancel' ? '放弃保存并离开页面' : '停留在当前页面'
          // })
        });
    },
    /** 查询角色 */
    selectJs() {
      let _this = this;
      _this.optionsRole = [];
      _this.$ajax
        .post("/api/selectJs", {})
        .then((res) => {
          if (res.data.code == "200") {
            for (let tmp of res.data.data) {
              _this.optionsRole.push({
                label: tmp.jsname,
                value: tmp.jsid,
              });
            }
          }
        });
    },
    /** 重置操作 */
    resetSearch(typeFlg) {
      // this.queryForm.yhmc = "";
      this.queryForm.yhbh = "";
      this.searchUser(typeFlg);
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.searchUser();
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.limit = val;
      this.currentPage = 1;
      this.searchUser();
    },
  },
  mounted() {
    this.searchUser();
    this.selectJs();
    this.$requestUtil
      .getCodeInfoById(["NORMAL_CODE_USER_STATE"])
      .then((tmpResult) => {
        // 用户状态
        let userStateCodeList = tmpResult["NORMAL_CODE_USER_STATE"];
        for (let tmp of userStateCodeList) {
          this.optionsUserState.push({
            label: tmp.name,
            value: tmp.code,
          });
        }
      });
    // 监听浏览器的宽和高
    this.screenHeight = document.body.clientHeight;
    window.addEventListener(
      "resize",
      () => (this.screenHeight = window.innerHeight),
      false
    );
  },
};
</script>

<style lang="scss" scoped>
.rightClass {
  margin: 10px 0;
}

</style>
